import { mapState } from 'vuex';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    props: {
        data: {
            type: Object,
            default: null,
        },

        touched: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            dataNew: {},
            STATE_CLASSES,
            valid: {},
            values: {},
        };
    },

    computed: {
        ...mapState({
            pageData: state => state.page.pageData,
            selectedElements: state => state.page.selectedElements,
        }),

        dataDefault() {
            const def = {};

            // populate defaultConfig with the default values from the schema
            Object.entries(this.schema).forEach((entry) => {
                const [key, schemaDef] = entry;

                def[key] = schemaDef.default;
            });

            return def;
        },

        isValid() {
            return Object.values(this.valid).every(v => !!v);
        },
    },

    watch: {
        dataNew: {
            handler() {
                this.setValidity();
                this.update();
            },
            deep: true,
        },

        touched() {
            this.setValidity();
        },
    },

    created() {
        this.setData();
        this.setValidity();
    },

    methods: {
        getInvalidClass(propName) {
            return { [STATE_CLASSES.INVALID]: this.touched && !this.valid[propName] };
        },

        setData() {
            this.dataNew = {
                ...this.dataDefault,
                ...this.data,
            };
        },

        setValidity() {
            this.valid = Object.keys(this.dataNew).reduce((obj, key) => {
                obj[key] = !this.schema[key] || !this.schema[key].required || !!this.dataNew[key];

                return obj;
            }, {});

            this.$emit('valid', this.isValid);
        },

        update() {
            this.$emit('input', this.dataNew);
        },
    },
};
